export const errorTypeByErrorMessage = {
  'failed to get short link by uuid': 'shortLinkExpired',
} as const;

export const notificationErrorsToSkip: ErrorType[] = ['shortLinkExpired'];
export const notificationErrorsToStopRetry: ErrorType[] = ['shortLinkExpired'];

export type ErrorType =
  | (typeof errorTypeByErrorMessage)[keyof typeof errorTypeByErrorMessage]
  | 'default';
